"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAttribute = exports.removeExistingHeadTagById = exports.removeExistingBodyTagById = exports.insertMetaTag = exports.insertImageTag = exports.insertIframeToBody = exports.insertHeadMetaTag = exports.insertBodyScriptTag = void 0;
var setAttribute = function setAttribute(el, name, value) {
  if (el && name && value) {
    el.setAttribute(name, value);
  }
};
exports.setAttribute = setAttribute;
var insertScriptTag = function insertScriptTag(data, domElement) {
  if (data) {
    var tagScript = window.document.createElement('script');
    setAttribute(tagScript, 'type', data.type);
    data.id && setAttribute(tagScript, 'id', data.id);
    setAttribute(tagScript, 'src', data.src);
    setAttribute(tagScript, 'async', true);
    setAttribute(tagScript, 'language', data.language);
    domElement.appendChild(tagScript);
  }
};
var insertBodyScriptTag = function insertBodyScriptTag(data) {
  insertScriptTag(data, window.document.body);
};
exports.insertBodyScriptTag = insertBodyScriptTag;
var insertImageTag = function insertImageTag(data, domElement) {
  if (data) {
    var image = window.document.createElement('img');
    image.setAttribute('height', '1');
    image.setAttribute('width', '1');
    image.setAttribute('style', 'display:none; border-style:none;');
    image.setAttribute('alt', '');
    image.setAttribute('src', data.src);
    data.id && image.setAttribute('id', data.id);
    domElement.appendChild(image);
  }
};
exports.insertImageTag = insertImageTag;
var insertIframeToBody = function insertIframeToBody(data) {
  if (data && data.src) {
    var iframe = window.document.createElement('iframe');
    iframe.width = '1';
    iframe.height = '1';
    iframe.frameborder = '0';
    iframe.style.display = 'none';
    iframe.src = data.src;
    if (data.id) {
      iframe.id = data.id;
    }
    window.document.body.appendChild(iframe);
  }
};
exports.insertIframeToBody = insertIframeToBody;
var insertMetaTag = function insertMetaTag(data, domElement) {
  if (data) {
    var tagMeta = window.document.createElement('meta');
    setAttribute(tagMeta, 'name', data.name);
    data.id && setAttribute(tagMeta, 'id', data.id);
    setAttribute(tagMeta, 'content', data.content);
    domElement.appendChild(tagMeta);
  }
};
exports.insertMetaTag = insertMetaTag;
var insertHeadMetaTag = function insertHeadMetaTag(data) {
  insertMetaTag(data, window.document.head);
};
exports.insertHeadMetaTag = insertHeadMetaTag;
var removeExistingHeadTagById = function removeExistingHeadTagById(id) {
  var scriptSelector = window.document.getElementById(id);
  if (scriptSelector) {
    window.document.head.removeChild(scriptSelector);
  }
};
exports.removeExistingHeadTagById = removeExistingHeadTagById;
var removeExistingBodyTagById = function removeExistingBodyTagById(id) {
  var scriptSelector = window.document.getElementById(id);
  if (scriptSelector) {
    window.document.body.removeChild(scriptSelector);
  }
};
exports.removeExistingBodyTagById = removeExistingBodyTagById;